export default __webpack_public_path__ + "27b60d0092cc19ce614de363d79f5344.png";